var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00395 12.694C6.86893 12.6974 5.77157 12.287 4.91731 11.5397C4.06304 10.7923 3.51043 9.75926 3.36291 8.63385C3.31506 8.26879 2.98032 8.01163 2.61525 8.05949C2.25019 8.10734 1.99303 8.44208 2.04089 8.80714C2.23055 10.2541 2.94105 11.5823 4.03939 12.5432C5.13774 13.504 6.54862 14.0317 8.00794 14.0273C9.46725 14.023 10.875 13.4869 11.9675 12.5195C13.0601 11.5521 13.7627 10.2196 13.9437 8.77155C14.1247 7.3235 13.7717 5.85911 12.9509 4.65252C12.1301 3.44593 10.8976 2.57985 9.4843 2.2164C8.07096 1.85296 6.57361 2.01706 5.27254 2.678C4.64063 2.99901 3.95819 3.44599 3.36856 4.00088V2.7205C3.36856 2.35231 3.07009 2.05383 2.7019 2.05383C2.33371 2.05383 2.03523 2.35231 2.03523 2.7205V6.05383C2.03523 6.42202 2.33371 6.7205 2.7019 6.7205H6.03523C6.40342 6.7205 6.7019 6.42202 6.7019 6.05383C6.7019 5.68564 6.40342 5.38716 6.03523 5.38716H3.88746C4.4028 4.77627 5.13307 4.24437 5.87642 3.86674C6.88836 3.35268 8.05297 3.22504 9.15223 3.50772C10.2515 3.7904 11.2101 4.46402 11.8485 5.40248C12.4869 6.34094 12.7614 7.47991 12.6206 8.60617C12.4798 9.73244 11.9334 10.7688 11.0836 11.5212C10.2339 12.2737 9.13897 12.6906 8.00395 12.694Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.b5a763279da7cc4f8838f07a068ad06f.svg";
export { ForwardRef as ReactComponent };